import {FormControl, FormField} from 'platform/components';
import {Grid, GridItem, VStack} from 'platform/foundation';

import {UseFormReturn, useWatch} from 'react-hook-form';

import i18n from '@dms/i18n';
import {testIds} from '@dms/routes';
import {VehicleType} from '@dms/teas';

import {useVehicleSeriesDefinitionContext} from '../hooks/useVehicleSeriesDefinitionContext';
import {VehicleSeriesDefinitionFormType} from '../types';
import {MakeSelectField} from './MakeSelectField';

type VehicleSeriesDefinitionFormFieldsProps = {
  control: FormControl<VehicleSeriesDefinitionFormType>;
  formApi: UseFormReturn<VehicleSeriesDefinitionFormType>;
};

export const VehicleSeriesDefinitionFormFields = (
  props: VehicleSeriesDefinitionFormFieldsProps
) => {
  const {vehicleTypes, branchList, seriesList, isSystem} = useVehicleSeriesDefinitionContext();

  const vehicleType = useWatch({
    control: props.control,
    name: 'vehicleType',
  });

  const vehicleTypeOptions = vehicleTypes.map((type) => ({
    label: type.label ?? '',
    value: type.value,
  }));

  const branchOptions = branchList.map((branch) => ({
    label: branch.marketingName ?? '',
    value: branch.id,
  }));

  const seriesOptions = seriesList.map((series) => ({
    label: series.name,
    value: series.id,
  }));

  const handleVehicleTypeChange = () => {
    props.formApi.setValue('makes', null);
  };

  return (
    <VStack spacing={4}>
      <Grid columns={2} spacing={4}>
        <FormField
          control={props.control}
          name="name"
          type="text"
          label={i18n.t('entity.seriesDefinition.labels.definitionName')}
          isRequired
        />
        <FormField
          control={props.control}
          name="vehicleType"
          type="choice"
          isDisabled={isSystem}
          isRequired={!isSystem}
          options={vehicleTypeOptions}
          label={i18n.t('entity.vehicle.labels.type')}
          placeholder={i18n.t('general.labels.select')}
          onChange={handleVehicleTypeChange}
        />
      </Grid>
      <Grid columns={2} spacing={4}>
        <GridItem span={2}>
          <MakeSelectField<VehicleSeriesDefinitionFormType>
            control={props.control}
            name="makes"
            label={i18n.t('entity.vehicle.labels.make')}
            vehicleType={vehicleType as VehicleType}
            isDisabled={isSystem}
            closeMenuOnSelect={false}
            hasOptionCheckbox
            data-testid={testIds.vehicles.edit('vehicleDefinition')}
          />
        </GridItem>
      </Grid>
      <Grid columns={2} spacing={4}>
        <FormField
          control={props.control}
          name="branchId"
          type="choice"
          isDisabled={isSystem}
          options={branchOptions}
          label={i18n.t('entity.branch.labels.branch')}
          placeholder={i18n.t('general.labels.select')}
        />
        <FormField
          control={props.control}
          name="seriesId"
          type="choice"
          isDisabled={isSystem}
          isRequired={!isSystem}
          options={seriesOptions}
          label={i18n.t('page.vehicleSeriesDefinition.labels.definitionVehicleSeries')}
          placeholder={i18n.t('general.labels.select')}
        />
      </Grid>
    </VStack>
  );
};
